import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Badge = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="badge icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.2439 1.82542L12 0L9.75603 1.82542L6.89999 1.36654L5.86937 4.06938L3.16653 5.1L3.62541 7.95604L1.79999 10.2L3.62541 12.444L3.16653 15.3L6 16.5L5.99999 24L12 21.6L18 24L18 16.5L20.8334 15.3L20.3746 12.444L22.2 10.2L20.3746 7.95604L20.8334 5.1L18.1306 4.06938L17.1 1.36654L14.2439 1.82542ZM9.74007 14.4637L7.33128 12.3597C6.79927 11.8951 6.75273 11.0832 7.22891 10.5612C7.69655 10.0486 8.49147 10.0098 9.00642 10.4767L10.2077 11.564L14.4173 6.74099C14.8842 6.20587 15.6961 6.15003 16.232 6.61613C16.7733 7.0861 16.8268 7.9066 16.3507 8.44249L11.0872 14.3776C10.7374 14.7716 10.1364 14.8096 9.74007 14.4637Z"
    />
  </svg>
)
